import { Pipe, PipeTransform } from '@angular/core';
import { fileSize } from '../utils/file-size';
import { isNil, Nillable } from '@web/utils';

@Pipe({
  name: 'filesize',
  standalone: true,
})
export class FilesizePipe implements PipeTransform {
  public transform(value: Nillable<number>): Nillable<string> {
    if (isNil(value)) {
      return value;
    }

    return fileSize(value);
  }
}
